"use strict";
import { commonPressStyle } from "ui/src/components/buttons/Button/components/CustomButtonFrame/constants";
export const withCommonPressStyle = (style) => ({
  ...commonPressStyle,
  ...style
});
